import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, mergeProps as _mergeProps, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex items-center justify-between px-2 h-72px bg-[var(--el-bg-color-overlay)] b-solid b-1 b-[var(--el-border-color)] b-l-none"
};
const _hoisted_2 = {
  class: "flex gap-[10px]"
};
const _hoisted_3 = {
  class: "text-[12px] text-gray-400"
};
const _hoisted_4 = {
  class: "flex gap-[12px] items-center"
};
const _hoisted_5 = {
  class: "flex gap-[16px] items-center"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "flex gap-[16px] items-center"
};
import { formatPast } from '@/utils/formatTime';
import audioUrl from '@/assets/audio/response.mp3';
import { inject, reactive, ref } from 'vue';
import Icon from '@/components/Icon/src/Icon.vue';
export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'Index'
  },
  __name: 'index',
  setup(__props) {
    const currentSong = inject('currentSong', {});
    const audioRef = ref(null);
    // 音频相关属性https://www.runoob.com/tags/ref-av-dom.html
    const audioProps = reactive({
      autoplay: true,
      paused: false,
      currentTime: '00:00',
      duration: '00:00',
      muted: false,
      volume: 50
    });
    function toggleStatus(type) {
      const audioElement = audioRef.value;
      if (!audioElement) return;
      audioProps[type] = !audioProps[type];
      if (type === 'paused') {
        if (audioProps.paused) {
          audioElement.pause();
        } else {
          audioElement.play();
        }
      }
    }
    // 更新播放位置
    function audioTimeUpdate(args) {
      audioProps.currentTime = formatPast(new Date(args.timeStamp), 'mm:ss');
    }
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_slider = _resolveComponent("el-slider");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_image, {
        src: "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png",
        class: "w-[45px]"
      }), _createElementVNode("div", null, [_createElementVNode("div", null, _toDisplayString(_unref(currentSong).name), 1), _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(currentSong).singer), 1)])]), _createElementVNode("div", _hoisted_4, [_createVNode(Icon, {
        icon: "majesticons:back-circle",
        size: 20,
        class: "text-gray-300 cursor-pointer"
      }), _createVNode(Icon, {
        icon: audioProps.paused ? 'mdi:arrow-right-drop-circle' : 'solar:pause-circle-bold',
        size: 30,
        class: "cursor-pointer",
        onClick: _cache[0] || (_cache[0] = $event => toggleStatus('paused'))
      }, null, 8, ["icon"]), _createVNode(Icon, {
        icon: "majesticons:next-circle",
        size: 20,
        class: "text-gray-300 cursor-pointer"
      }), _createElementVNode("div", _hoisted_5, [_createElementVNode("span", null, _toDisplayString(audioProps.currentTime), 1), _createVNode(_component_el_slider, {
        modelValue: audioProps.duration,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => audioProps.duration = $event),
        color: "#409eff",
        class: "w-[160px!important]"
      }, null, 8, ["modelValue"]), _createElementVNode("span", null, _toDisplayString(audioProps.duration), 1)]), _withDirectives(_createElementVNode("audio", _mergeProps(audioProps, {
        ref_key: "audioRef",
        ref: audioRef,
        controls: "",
        onTimeupdate: audioTimeUpdate
      }), [_createElementVNode("source", {
        src: _unref(audioUrl)
      }, null, 8, _hoisted_6)], 16), [[_vShow, !audioProps]])]), _createElementVNode("div", _hoisted_7, [_createVNode(Icon, {
        icon: audioProps.muted ? 'tabler:volume-off' : 'tabler:volume',
        size: 20,
        class: "cursor-pointer",
        onClick: _cache[2] || (_cache[2] = $event => toggleStatus('muted'))
      }, null, 8, ["icon"]), _createVNode(_component_el_slider, {
        modelValue: audioProps.volume,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => audioProps.volume = $event),
        color: "#409eff",
        class: "w-[160px!important]"
      }, null, 8, ["modelValue"])])]);
    };
  }
});